import { render, staticRenderFns } from "./CreatePayment.vue?vue&type=template&id=72fca342&scoped=true&"
import script from "./CreatePayment.vue?vue&type=script&lang=js&"
export * from "./CreatePayment.vue?vue&type=script&lang=js&"
import style0 from "./CreatePayment.vue?vue&type=style&index=0&id=72fca342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fca342",
  null
  
)

export default component.exports